

import React, { useEffect, useState } from "react";
import { TiPlus } from "react-icons/ti";
import { FaEye } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { HiSortAscending, HiSortDescending } from "react-icons/hi"; // Import sort icons
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAccident, getAllAccident, updateAccident } from "../redux/apiCalls/accidentApiCall";
import { format } from "date-fns";
import Pagination from "./Pagination";

function MeineAuftrage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accidents, getLoading, numberOfAuftrage } = useSelector((state) => state.accident);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(6);
  const [filters, setFilters] = useState({ company: '', partner: '', status: null, phase:"all" });
  const [status, setStatus] = useState({});
  const [phase, setPhase] = useState(null);
  const [sortOrder, setSortOrder] = useState('desc'); // New state for sorting
  const role = sessionStorage.getItem("role");


  useEffect(() => {
    dispatch(getAllAccident(currentPage, perPage)).then((response) => {
      console.log("API Response:", response);
      
    });
  }, [dispatch , currentPage, perPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const totalPages = Math.ceil((numberOfAuftrage || 0) / perPage);

  const handleDelete = (id) => {
    if (window.confirm("Möchten Sie diesen Vorfall löschen?")) {
      dispatch(deleteAccident(id));
    }
  };

const toggleStatus = async(id, currentStatus) => {
  const updatedStatus = !currentStatus;
  const updatedData = {
    isPayed: updatedStatus,
  };
   await dispatch(updateAccident(id, updatedData,navigate));
  dispatch(getAllAccident(currentPage, perPage));
}

// const handlePhaseChange = (id, newPhase) => {
//   dispatch(updateAccident(id, { phase: newPhase }));
//   dispatch(getAllAccident(currentPage, perPage));
// };
  const filterAccidents = () => {
    return (accidents.accidents || []).filter(accident => {
      const matchesCompany = filters.company ? accident.company.toLowerCase().includes(filters.company.toLowerCase()) : true;
      const matchesPartner = filters.partner ? accident.user?.username.toLowerCase().includes(filters.partner.toLowerCase()) : true;
      const matchesPaymentStatus = filters.status !== null ? accident.isPayed === filters.status : true;
      // const matchesPaymentPhase = filters.phase !== null ? accident.phase === filters.phase : null;
      const matchesPaymentPhase = filters.phase !== "all" 
      ? accident.phase === filters.phase 
      : true;
      return matchesCompany && matchesPartner && matchesPaymentStatus&&matchesPaymentPhase;
    });
  };

  const filteredAccidents = filterAccidents();

  // Sort accidents based on the sortOrder
  const sortedAccidents = [...filteredAccidents].sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });


  const handlePhaseChange = async (id, newPhase) => {
    try {
      // تحديث المرحلة على الخادم
      await dispatch(updateAccident(id, { phase: newPhase }));
      
      // إعادة تحميل البيانات لتحديث الواجهة
      dispatch(getAllAccident(currentPage, perPage));
    } catch (error) {
      console.error("Error updating phase:", error);
    }
  };


  if (getLoading) {
    return <div>Loading...</div>;
  }
  const user = JSON.parse(sessionStorage.getItem("user"));

 // ... الكود الحالي

return (
  <div className="flex flex-col w-full px-2 md:px-0">
    {/* Header Section */}
    <div className="flex flex-col w-full">
      <div className="pl-2 md:pl-5 flex flex-col md:flex-row justify-between w-full pt-2 items-center">
        <h1 className="font-montserrat text-xl md:text-2xl font-bold mb-2 md:mb-0 pt-7">
          {role !== "admin" && <span>Meine</span>}Aufträge
        </h1>
        <div className="w-full md:w-[40%] flex flex-col md:flex-row gap-2 md:justify-between">
          <button 
            onClick={() => navigate("/AddNeuenAuftrag")} 
            className="border border-black bg-yellow-300 rounded-lg h-9 text-sm flex items-center justify-center px-2"
          >
            <TiPlus /><span className="ml-1">neuer Auftrag</span>
          </button>
          <div className="flex items-center justify-center md:justify-end">
            <div className="text-center md:text-right">
              <h4 className="text-sm">{user.username}</h4>
              <p className="text-xs text-gray-600">{user.role}</p>
            </div>
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-gray-800 ml-2">
              <img src={user.profilePhoto?.url} alt="img-pro" className="w-full h-full rounded-full" />
            </div>
          </div>
        </div>
      </div>
      <div className="border-b border-black w-full mt-3"></div>
    </div>

    {/* Filters Section */}
    <div className="flex flex-col md:flex-row gap-2 mt-4">
      <input
        type="text"
        placeholder="Unternehmen"
        value={filters.company}
        onChange={(e) => setFilters({ ...filters, company: e.target.value })}
        className="border p-2 rounded-md text-sm md:text-base"
      />
      <input
        type="text"
        placeholder="Partner"
        value={filters.partner}
        onChange={(e) => setFilters({ ...filters, partner: e.target.value })}
        className="border p-2 rounded-md text-sm md:text-base"
        
      />
      <select
        value={filters.status}
        onChange={(e) => setFilters({ ...filters, status: e.target.value ? JSON.parse(e.target.value) : null })}
        className="border p-2 rounded-md text-sm md:text-base"
      >
        <option value="">Zahlungsstatus</option>
        <option value="true">Bezahlt</option>
        <option value="false">Nicht bezahlt</option>
      </select>
      <select
        value={filters.phase}
        onChange={(e) => setFilters({ ...filters, phase: e.target.value ? e.target.value: "all" })}
        className="border p-2 rounded-md text-sm md:text-base"
      >
        <option value="all">Phase</option>
        <option value="Eingegangen">Eingegangen</option>
        <option value="in Bearbeitung">in Bearbeitung</option>
        <option value="Beim Rechtsanwalt">Beim Rechtsanwalt</option>
        <option value="Erledigt">Erledigt</option>
      </select>
    </div>

    {/* Sorting Controls */}
    <div className="flex justify-end mt-2 gap-1">
      <button
        onClick={() => setSortOrder('asc')}
        className={`flex items-center border p-1 md:p-2 rounded-l-md text-sm ${sortOrder === 'asc' ? 'bg-gray-300' : 'bg-white'}`}
      >
        <HiSortAscending className="mr-1" /> Auf
      </button>
      <button
        onClick={() => setSortOrder('desc')}
        className={`flex items-center border p-1 md:p-2 rounded-r-md text-sm ${sortOrder === 'desc' ? 'bg-gray-300' : 'bg-white'}`}
      >
        <HiSortDescending className="mr-1" /> Ab
      </button>
    </div>

    {/* Table Section */}
    <div className="overflow-x-auto pt-4">
      {sortedAccidents.length > 0 ? (
        <table className="min-w-full border border-gray-300">
          <thead className="bg-gradient-to-b from-[#3a3a3a] to-[#1a1a1a] text-white">
            <tr>
              {role === "admin" && <th className="px-2 py-2 text-left border-b text-sm md:text-base">Partner</th>}
              <th className="px-2 py-2 text-left border-b text-sm md:text-base">Kunde</th>
              <th className="px-2 py-2 text-left border-b text-sm md:text-base">Datum</th>
              <th className="px-2 py-2 text-left border-b text-sm md:text-base hidden md:table-cell">Kennzeichen</th>
              {role === "admin" && <th className="px-2 py-2 text-left border-b text-sm md:text-base">Status</th>}
              <th className="px-2 py-2 text-left border-b text-sm md:text-base">Phase</th>
              <th className="px-2 py-2 text-center border-b text-sm md:text-base">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {sortedAccidents.map((accident) => (
              <tr key={accident.id} className="bg-gray-100">
                {role === "admin" && <td className="px-2 py-2 border-b text-sm md:text-base">{accident.user?.username}</td>}
                <td className="px-2 py-2 border-b text-sm md:text-base">{accident.kundenName}</td>
                <td className="px-2 py-2 border-b text-sm md:text-base">
                  {accident.createdAt ? format(new Date(accident.createdAt), "dd.MM.yy") : ""}
                </td>
                <td className="px-2 py-2 border-b text-sm md:text-base hidden md:table-cell">{accident.kundenKem}</td>
                {role === "admin" && (
                  <td className="px-2 py-2 border-b">
                    <div
                      className={`w-10 h-5 md:w-12 md:h-6 flex items-center rounded-full p-1 cursor-pointer ${accident.isPayed ? "bg-green-500" : "bg-gray-300"}`}
                      onClick={() => toggleStatus(accident.id, accident.isPayed)}
                    >
                      <div
                        className={`w-4 h-4 md:w-5 md:h-5 bg-white rounded-full shadow-md transform ${accident.isPayed ? "translate-x-4 md:translate-x-6" : ""}`}
                      ></div>
                    </div>
                  </td>
                )}
                <td className="px-2 py-2 border-b text-sm md:text-base">
                  {role === "admin" ? (
                    <select
                      value={accident.phase || "Eingegangen"}
                      onChange={(e) => handlePhaseChange(accident.id, e.target.value)}
                      className="border p-1 text-sm md:text-base"
                    >
                      <option value="Eingegangen">Eingegangen</option>
                      <option value="in Bearbeitung">in Bearbeitung</option>
                      <option value="Beim Rechtsanwalt">Beim Rechtsanwalt</option>
                      <option value="Erledigt">Erledigt</option>
                    </select>
                  ) : (
                    <span>{accident.phase}</span>
                  )}
                </td>
                <td className="px-2 py-2 text-center border-b space-x-1">
                  <button 
                    onClick={() => navigate(`/aftrageEye/${accident._id}`)} 
                    className="text-green-500 hover:text-green-700"
                  >
                    <FaEye className="text-lg" />
                  </button>
                  {role === "admin" && (
                    <button 
                      onClick={() => handleDelete(accident._id)} 
                      className="text-red-500 hover:text-red-700 ml-1"
                    >
                      <RiDeleteBin6Line className="text-lg" />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-center py-4">Keine Aufträge gefunden</div>
      )}
    </div>
    
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
    />
  </div>
);
}

export default MeineAuftrage;